
import { Wrapper } from '@klv/utils/wrapper';
import Buttons from '@klv/molecules/buttons';
import { generateClassName } from '@klv/shared/utils/functions';
import ModalTrigger from '@klv/molecules/video-modal-trigger';
import { getBackgroundType } from '@klv/utils/wrapper/functions';

import * as styles from './styles/main-cta.module.scss';

import type { IMainCta } from './types';

const MainCta = ({
  useDeprecatedBackground = true,
  background,
  backgroundColor,
  bodyCopy,
  buttons,
  className,
  customPadding = { customPaddingBottom: 'md', customPaddingTop: 'md' },
  headline,
  fadeIn,
  image,
  videoHeadline,
  videoUrl,
}: IMainCta) => {
  const hasImage = !!image?.sourceUrl;
  const selectedBackground = useDeprecatedBackground ? background : backgroundColor;
  const backgroundType = getBackgroundType(selectedBackground);

  return (
    <Wrapper 
      className={generateClassName([styles.mainCta, backgroundType === 'dark' ? styles.dark : '', className])}
      contained={true}
      inlinePadding={true}
      grid={true}
      fadeIn={fadeIn ? .25 : 0}
      backgroundColor={selectedBackground}
      customPadding={customPadding}
    >
      {hasImage && (
        <div className={styles.imageWrapper}>
          {videoUrl ? (
            <ModalTrigger modalHeadline={videoHeadline} videoUrl={videoUrl}>
              <img
                alt={image.altText}
                className={styles.image}
                height={image?.mediaDetails?.height || 392}
                sizes="(max-width: 575px) 100vw, (max-width: 1366px) 50vw, 588px"
                src={image.sourceUrl}
                srcSet={image.srcSet}
                width={image?.mediaDetails?.width || 588}
              />
            </ModalTrigger>
          ) : (
            <img
              alt={image.altText}
              className={styles.image}
              height={image?.mediaDetails?.height || 392}
              sizes="(max-width: 575px) 100vw, (max-width: 1366px) 50vw, 588px"
              src={image.sourceUrl}
              srcSet={image.srcSet}
              width={image?.mediaDetails?.width || 588}
            />
          )}
        </div>
      )}

      <div className={styles.textContent}>
        { headline && (
          <div className={generateClassName(['h3', styles.headline])}>
            {headline}
          </div>
        )}
        { bodyCopy && (
          <div className={generateClassName(['p2', styles.bodyCopy])} dangerouslySetInnerHTML={{ __html: bodyCopy }} />
        )}
        {buttons && buttons.length > 0 && (
          <Buttons
            buttons={buttons}
            variants={['ghost']}
            buttonColor={backgroundType === 'dark' ? 'light' : 'dark'}
          />
        )}
      </div>
    </Wrapper>
  );
};

export default MainCta;
